export const LogoCircle = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <g transform="scale(0.03125)">
        <path d="M128 171a128 128 0 0 1 256 0c0 149 64 192 64 192H64s64-43 64-192z" fill="#AECBFA" stroke="#4A90E2" stroke-width="28" stroke-linejoin="round"/>
        <path d="M244 30a12 12 0 1 1 24 0" fill="none" stroke="#4A90E2" stroke-width="24" stroke-linecap="round"/>
        <path d="M213 452a44 44 0 0 0 86 0" fill="none" stroke="#4A90E2" stroke-width="28" stroke-linecap="round"/>
        <path d="M430 96l36-32" stroke="#4A90E2" stroke-width="24" stroke-linecap="round"/>
        <path d="M458 158l38-14" stroke="#4A90E2" stroke-width="24" stroke-linecap="round"/>
        <g transform="translate(292 300) scale(8.5)">
          <path d="M3 11 22 2 13 21 11 13 3 11z" fill="#FFFFFF" stroke="#4A90E2" stroke-width="3" stroke-linejoin="round"/>
        </g>
      </g>
    </svg>
  );
};
